export const LOGIN_TO_APP = `admin/auth/login`;
export const SIGNUP_TO_APP = `admin/auth/signup`;
export const VERIFY_OTP_TO_APP = `auth/verifyotp`;


export const CAB_CATEGORY = `admin/cabs/addCabCategory`;